import { Search } from 'lucide-react';
import type { HTMLAttributes, InputHTMLAttributes, ReactNode } from 'react';

function classes(...names: Array<string | undefined>) {
  return names.filter(Boolean).join(' ');
}

export function CollectionToolbar({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={classes('dui-collection-toolbar', className)} {...props} />;
}

export function CollectionSearch({
  label,
  className,
  ...props
}: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
}) {
  return (
    <label className={classes('dui-collection-search', className)}>
      <Search size={16} aria-hidden="true" />
      <span className="sr-only">{label}</span>
      <input type="search" {...props} />
    </label>
  );
}

export function CollectionSurface({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={classes('dui-collection', className)} {...props} />;
}

export function CollectionHeader({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={classes('dui-collection-header', className)} {...props} />;
}

export function CollectionRow({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <article className={classes('dui-collection-row', className)} {...props} />;
}

export function CollectionThumbnail({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span className={classes('dui-collection-thumbnail', className)} {...props} />;
}

export function CollectionPrimary({
  title,
  detail,
  className,
}: {
  title: ReactNode;
  detail?: ReactNode;
  className?: string;
}) {
  return (
    <span className={classes('dui-collection-primary', className)}>
      <strong>{title}</strong>
      {detail ? <small>{detail}</small> : null}
    </span>
  );
}

export function CollectionMeta({
  label,
  children,
  className,
}: {
  label: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={classes('dui-collection-meta', className)}>
      <small>{label}</small>
      <strong>{children}</strong>
    </span>
  );
}
